import { useLocation } from 'react-router-dom';
import React, {useEffect} from 'react';
import Modal from 'react-modal';
import {connect} from "react-redux";
import ProductGallery from "../../partials/product/media/product-gallery";
import ProductDetails from "../../partials/product/details/product-details";

// Import Action
import {hideQuickView} from "../../../store/modal/actions";

const customStyles = {
    content: {
        position: 'relative',
        maxWidth: '960px',
        width: 'calc(100% - 4rem)',
        margin: '0 2rem',
        padding: 0,
        overflow: 'hidden auto',
        maxHeight: 'calc(100vh - 4rem)',
        background: '#fff',
        border: 'none',
        borderRadius: '16px',
        boxShadow: '0 24px 48px rgba(17, 24, 39, 0.18)',
    }
};

function QuickModal ( props ) {
    const { modalShow, product } = props;
    const location = useLocation();

    useEffect( () => {
        closeModal();
    }, [location])

    if ( !product ) {
        return;
    }

    function closeModal () {
        if ( !document.querySelector( '.open-modal' ) ) return;
        document.querySelector( '.open-modal' ).classList.add( "close-modal" );

        props.hideQuickView();
    }

    return (
        <>
            <Modal
                ariaHideApp={false}
                isOpen={ modalShow }
                onRequestClose={ closeModal }
                className="product-single-container product-single-default product-quick-view product-quick-view-modern custom-scrollbar mb-0"
                overlayClassName="ajax-overlay open-modal quickview-overlay-modern"
                shouldReturnFocusAfterClose={ false }
                style={ customStyles }
            >
                <div className={ `row skeleton-body skel-shop-products loaded` }>
                    <ProductGallery product={ product } parent=".product-quick-view" adClass="col-md-6 mb-md-0" />

                    <div className="col-md-6">
                        <ProductDetails product={ product } parent=".product-quick-view" isNav={ false } adClass="mb-0" />
                    </div>
                </div>

                <button title="Close (Esc)" type="button" className="mfp-close" onClick={ closeModal } >×</button>
            </Modal>
        </>
    )
}

const mapStateToProps = ( state ) => {
    return {
        product: state.modal.single,
        modalShow: state.modal.quickShow,
    }
}

const mapDispatchToProps = {
    hideQuickView
}

export default ( connect( mapStateToProps, mapDispatchToProps )( QuickModal ) );
